import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import {
	type CsvSchemaColumn,
	httpGetCsvUploadSchema
} from '@/features/luxe-submissions/http/luxe-submissions.http'

const TEMPLATE_FILE_NAME = 'luxe-csv-template.csv'

const CSV_ESCAPE_REGEX = /[",\n\r]/
const CSV_QUOTE_REGEX = /"/g
const BOM = '\uFEFF'

const escapeCsvValue = (value: string) =>
	CSV_ESCAPE_REGEX.test(value)
		? `"${value.replace(CSV_QUOTE_REGEX, '""')}"`
		: value
const buildCsvTemplate = (columns: CsvSchemaColumn[]) => {
	const header = columns.map((c) => c.name)
	const exampleRow = columns.map((c) => c.example ?? '')
	const hasExamples = exampleRow.some((value) => value !== '')
	const rows = hasExamples ? [header, exampleRow] : [header]
	return rows.map((row) => row.map(escapeCsvValue).join(',')).join('\n')
}

export const CSV_TEMPLATE_QUERY_KEY = 'csv-template'

export const useGetCsvTemplate = (enabled = true) => {
	const { data: csv, isLoading } = useQuery({
		queryKey: [CSV_TEMPLATE_QUERY_KEY],
		queryFn: async () => {
			const { columns } = await httpGetCsvUploadSchema()
			return buildCsvTemplate(columns)
		},
		enabled
	})

	const [url, setUrl] = useState<string>()

	useEffect(() => {
		if (!csv) {
			return
		}

		const blob = new Blob([BOM + csv], {
			type: 'text/csv;charset=utf-8;'
		})
		const objectUrl = URL.createObjectURL(blob)

		setUrl(objectUrl)

		return () => URL.revokeObjectURL(objectUrl)
	}, [csv])

	return {
		data: url ? { url, fileName: TEMPLATE_FILE_NAME } : undefined,
		isLoading
	}
}
